import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    h: "Acceptance of these terms",
    body: [
      "By using havenandhillproperties.com (the \u201cSite\u201d) you accept these Terms & Conditions. If you do not agree, please do not use the Site. The Site is operated by Haven and Hill Properties L.L.C, a real-estate brokerage based in Dubai, United Arab Emirates.",
    ],
  },
  {
    h: "What the Site is — and is not",
    body: [
      "The Site provides general information about buying property in Dubai, curated project selections, market commentary, an AI-assisted concierge, and a way to request consultations and virtual viewings.",
      "Content on the Site — including the buyer's guide, checklist, market trends, calculator outputs and AI concierge answers — is general guidance based on public Dubai Land Department (DLD) and RERA information. It is not legal, tax, investment, valuation or financial advice, and it is not a property appraisal. Always verify current rules, fees and project registrations directly with the DLD, the Dubai REST app, and licensed professionals before acting.",
      "No agency relationship is formed by using this Site. A brokerage relationship begins only when a written agreement is signed in accordance with RERA requirements.",
    ],
  },
  {
    h: "Property information and advertising",
    body: [
      "Listings, prices, payment plans, yields, handover dates and project details are indicative, may be sample or illustrative selections, and can change or be withdrawn without notice. Descriptions do not constitute an offer capable of acceptance.",
      "As required by RERA advertising rules, every genuine property advertisement carries a Trakheesi permit number; verify permits and broker cards on the Dubai REST app. Off-plan purchases must be paid only into DLD-approved project escrow accounts (Law No. 8 of 2007).",
    ],
  },
  {
    h: "Appointments, the concierge and reminders",
    body: [
      "Consultation requests are subject to confirmation by our team; a request alone does not guarantee a slot. Meeting links and reminders are sent by email to the address you provide — you are responsible for its accuracy.",
      "The AI concierge answers general questions only. Do not share passwords, OTPs, card numbers or identification documents in chat.",
    ],
  },
  {
    h: "Digital purchases (buyer's guide PDF)",
    body: [
      "The Dubai Buyer's Mini Guide PDF is sold via Razorpay at the price shown at checkout. Delivery is by instant download after payment confirmation. Because digital content is delivered immediately, purchases are final; if your download fails, contact support@havenandhillproperties.com within 7 days and we will re-deliver or refund.",
      "The guide is licensed for personal use — you may share it with family and partners, but not resell or republish it.",
    ],
  },
  {
    h: "Intellectual property",
    body: [
      "All content, design, logos and text on the Site are owned by or licensed to Haven and Hill Properties L.L.C and may not be copied, reproduced or distributed without written permission, except for personal, non-commercial use.",
    ],
  },
  {
    h: "Third-party services",
    body: [
      "The Site links to or embeds third-party services (Zoom, WhatsApp, Razorpay, mapping and developer resources). We are not responsible for their content, availability or policies; their own terms apply when you use them.",
    ],
  },
  {
    h: "Limitation of liability",
    body: [
      "To the maximum extent permitted by UAE law, we are not liable for any loss arising from reliance on Site content, from interruptions or errors, or from third-party services. Nothing in these terms excludes liability that cannot be excluded by law.",
    ],
  },
  {
    h: "Governing law and disputes",
    body: [
      "These terms are governed by the laws of the Emirate of Dubai and the applicable federal laws of the United Arab Emirates. Disputes are subject to the exclusive jurisdiction of the courts of Dubai.",
    ],
  },
  {
    h: "Changes and contact",
    body: [
      "We may update these terms from time to time; the date above shows the current version. Continued use of the Site after changes constitutes acceptance.",
      "Contact: support@havenandhillproperties.com \u00b7 WhatsApp +971 58 812 3628.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage
      title="Terms & Conditions"
      updated="July 2026"
      path="/terms"
      description="Terms of use for havenandhillproperties.com — services, disclaimers, digital purchases, liability and governing law (Dubai, UAE)."
      intro="These terms govern your use of this website and the services offered through it, including consultations, the AI concierge and the paid buyer's guide."
      sections={SECTIONS}
    />
  );
}
